// extracted by mini-css-extract-plugin
module.exports = {"cart":"PictoCart_cart__w3ig7","connected":"PictoCart_connected__gMzkF"};